import { VECTORS } from '../components/simConstants'

const VECTOR_BY_API = {
  link: 'link',
  url: 'link',
  dataEntry: 'dataEntry',
  data_entry: 'dataEntry',
  attachment: 'attachmentHtml',
}

const attachmentVectorKey = (format) => {
  if (!format) {
    return 'attachmentHtml'
  }

  const normalized = String(format).toUpperCase()
  const byFormat = {
    HTML: 'attachmentHtml',
    PDF: 'attachmentPdf',
    DOCX: 'attachmentDocx',
    XLS: 'attachmentXls',
    XLSX: 'attachmentXls',
  }

  return byFormat[normalized] || 'attachmentHtml'
}

const resolveVector = (payload) => {
  if (payload.fileFormat || payload.file_format || payload.vector === 'attachment') {
    return VECTORS[attachmentVectorKey(payload.fileFormat || payload.file_format)]
  }

  const key = VECTOR_BY_API[payload.vector] || 'dataEntry'
  return VECTORS[key]
}

const resolvePhase = (payload) => {
  if (
    payload.phase === 'sending' ||
    payload.phase === 'collecting' ||
    payload.phase === 'completed'
  ) {
    return payload.phase
  }

  return 'collecting'
}

const adaptDepartment = (row) => {
  if (!row || !row.name) {
    return null
  }

  const aggregateOf = row.aggregateOf ?? row.aggregate_of

  return {
    name: row.name,
    delivered: row.delivered ?? 0,
    hits: row.hits ?? row.lured ?? row.reported ?? 0,
    deep: row.deep ?? row.submitted ?? row.dataSubmitted ?? row.data_submitted ?? 0,
    ...(aggregateOf?.length ? { aggregateOf } : {}),
  }
}

const adaptDepartments = (rows) =>
  Array.isArray(rows) ? rows.map(adaptDepartment).filter(Boolean) : []

export const EMPTY_DEPARTMENT_OUTCOMES = {
  available: false,
  vector: VECTORS.dataEntry,
  delivered: 0,
  scheduled: 0,
  phase: null,
  lured: [],
  reporting: [],
}

export const adaptSimulationDepartmentOutcomes = (payload) => {
  if (payload == null || payload.available === false) {
    return EMPTY_DEPARTMENT_OUTCOMES
  }

  return {
    available: true,
    vector: resolveVector(payload),
    delivered: payload.delivered ?? 0,
    scheduled: payload.scheduled ?? 0,
    phase: resolvePhase(payload),
    lured: adaptDepartments(payload.lured),
    reporting: adaptDepartments(payload.reporting),
  }
}
